import { defineMessages } from 'react-intl';

export default defineMessages({
  videoConsultation: 'Följande tid är en videokonsultation'
});
